/**
 * Cart Upsell Tracking
 * 
 * Listens for successful add-to-cart events from upsell forms and sets
 * cart attributes to tag the order. Cart attributes propagate to the order
 * and are visible in Shopify admin for filtering/reporting.
 *
 * Sets: _upsell_used = "true", _upsell_types = "cart_upsell,generic_upsell,deal_upsell"
 * (underscore prefix hides from customer but visible in admin). The cart's
 * upgrade offer (cart-upgrade-offer.js) writes the same attributes itself,
 * adding "upgrade_upsell", since it swaps lines rather than submitting a form.
 *
 * Orders placed before the upsell rework carry the older values
 * "upgrade" / "add_on" / "goes_well_with" — worth knowing when reporting.
 */
(function () {
  function getUpsellTypeFromEvent(event) {
    if (!event || !event.target) return null;
    const form = event.target.closest('[data-upsell-type]');
    return form ? form.dataset.upsellType : null;
  }

  function updateCartAttributes(upsellType) {
    // Fetch current cart to check existing attributes
    fetch('/cart.js', { method: 'GET', headers: { 'Content-Type': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var currentTypes = (cart.attributes && cart.attributes['_upsell_types']) || '';
        var typesArray = currentTypes ? currentTypes.split(',') : [];

        if (typesArray.indexOf(upsellType) === -1) {
          typesArray.push(upsellType);
        }

        var attributes = {
          '_upsell_used': 'true',
          '_upsell_types': typesArray.join(',')
        };

        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes: attributes })
        });
      })
      .catch(function (e) {
        console.warn('[upsell-tracking] Failed to update cart attributes:', e);
      });
  }

  // The tag comes off again once the cart holds no upsell line: it used to
  // stick after the upsell was removed, so an order with no upsell on it
  // still counted as one in reporting.
  function clearIfNoUpsellLeft(cart) {
    if (!cart || !Array.isArray(cart.items)) return;
    var used = cart.attributes && cart.attributes['_upsell_used'] === 'true';
    if (!used) return;
    var stillHasUpsell = cart.items.some(function (item) {
      return item.properties && item.properties['_upsell_type'];
    });
    if (stillHasUpsell) return;
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { '_upsell_used': '', '_upsell_types': '' } })
    }).catch(function (e) {
      console.warn('[upsell-tracking] Failed to clear cart attributes:', e);
    });
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      var cart = event && event.cartData;
      if (cart && Array.isArray(cart.items) && cart.attributes) {
        clearIfNoUpsellLeft(cart);
      } else {
        fetch('/cart.js').then(function (r) { return r.json(); }).then(clearIfNoUpsellLeft).catch(function () {});
      }
    });
  }

  // Listen for form submissions on upsell forms
  document.addEventListener('submit', function (event) {
    var upsellForm = event.target.closest('[data-upsell-type]');
    if (!upsellForm) return;

    var upsellType = upsellForm.dataset.upsellType;
    if (!upsellType) return;

    // Delay slightly to let the add-to-cart complete first
    setTimeout(function () {
      updateCartAttributes(upsellType);
    }, 1000);
  });
})();
